export const HOTJAR_ATTR = "data-hj-suppress";
export const HOTJAR_PROP = "hjSuppress";

/**
 * Use it data attribute to suppress data in HotJar recordings§
 * https://help.hotjar.com/hc/en-us/articles/115012439167-How-to-Suppress-Elements-and-Images-from-Data
 */

export interface IHotjarProps {
  [HOTJAR_PROP]?: boolean;
}
